import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// 1. IMPORT ROUTER COMPONENTS
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import IntroOverlay from "./Components/IntroOverlay/IntroOverlay";
import "./App.css";
import whatsappImg from "./assets/whatsapp.png";

import ClientSection from "./Components/ClientSection/ClientSection";
import ScrollStack from "./Components/ScrollStack/ScrollStack";
import BrandIdentity from "./Components/ScrollStack/ScrollComponents/BrandIdentity/BrandIdentity";
import UiUx from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Ui&Ux";
import Digital from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Digital";
import PhotoVideoSection from "./Components/ScrollStack/ScrollComponents/BrandIdentity/PhotoVideo";
import PrintSignage from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Print";
import Campaigns from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Campaigns";
import Testimonials from "./Components/Testimonials/Testimonials";
import Footer from "./Components/Footer/Footer";
import AboutUs from "./Components/AboutUs/AboutUs";
import Navbar from "./Components/Navigation/Navigation";
import { VelocityText } from "./Components/ScrollStack/ScrollComponents/WhatWeBuild/WhatWeBuild";
import FullAbout from "./Components/About/FullAbout"; // Ensure this path is correct
import Works from "./Components/Works/Work";
import ContactStack from "./Components/ContactPage/ContactPage";
import FullContact from "./Components/ContactUs/ContactUs";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";

import SmoothScroll from "./Components/SmoothScroll/SmoothScroll";
import HeroVideo from "./Components/Hero1/Hero1";
import Team from "./Components/Team/Team";

function App() {
  const [loading, setLoading] = useState(true);

  const [showContact, setShowContact] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // --- FIX: Defined the missing sectionStyle variable ---
  const sectionStyle = { scrollMarginTop: "100px" };

  return (
    <Router>
      <SmoothScroll>
        <div className="App">
          {loading ? (
            <IntroOverlay />
          ) : (
            <Routes>
              {/* ROUTE 1: HOME PAGE (Your existing one-page layout) */}
              <Route
                path="/"
                element={
                  <>
                    <ScrollToTop />
                    <Navbar />

                    <section id="home" style={sectionStyle}>
                      <HeroVideo />
                    </section>

                    {/* ID: home */}
                    {/*  <section id="home" style={sectionStyle}>
                      <Hero />
                    </section> */}



                    <ClientSection />

                    {/* ID: about */}
                    <section style={sectionStyle}>
                      <AboutUs />
                    </section>



                    {/* ID: service */}
                    {/*     <section id="service" style={sectionStyle}>
                      <ServicesSection />
                    </section> */}

                    {/* ID: services (ScrollStack) */}
                    <section id="services" style={sectionStyle}>
                      <ScrollStack>

                        <BrandIdentity />
                        <UiUx />
                        <Digital />
                        <PhotoVideoSection />
                        <PrintSignage />
                        <Campaigns />
                        <VelocityText />
                      </ScrollStack>
                    </section>

                    {/*  <section id="project" style={sectionStyle}>
                      <ProjectSection />
                    </section> */}

                    <Testimonials />

                    {/* ID: contact (inside Footer usually, but if you have a separate section add it here) */}

                    <section
                      id="footer"
                      style={sectionStyle}
                    >
                      <Footer onContactClick={() => setShowContact(true)} />

                      {/* The Contact Stack Section */}
                      {showContact && (
                        <ContactStack onClose={() => setShowContact(false)} />
                      )}
                    </section>

                    {/* Fixed WhatsApp Icon */}
                    <a
                      href="https://wa.me/7540001028"
                      className="whatsapp-float"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        position: "fixed",
                        bottom: "30px",
                        right: "20px",
                        zIndex: 9999,
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={whatsappImg}
                        alt="WhatsApp Chat"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                        }}
                      />
                    </a>
                  </>
                }
              />

              {/* ROUTE 2: THE NEW FULL ABOUT PAGE */}
              <Route path="/about" element={<FullAbout />} />
              <Route path="/works" element={<Works />} />
              <Route path="/contact" element={<FullContact />} />
              <Route path="/team" element={<Team />} />
            </Routes>
          )}
        </div>
      </SmoothScroll>
    </Router>
  );
}

export default App;
